module.exports = __webpack_public_path__ + "img/Tennis.5c7e0ead.svg";